<template>
  <div class="main-wrapper">

    <div class="main-scroll">
      <Navs></Navs>
      <forget-passwd></forget-passwd>
      <Foots class="foots"></Foots>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>
<script>
import Navs from '../common/navs';
import Foots from '../common/foots';
import ForgetPasswd from './forgetpasswd';
import BottomBacktop from '../common/BottomBacktop';


export default {
  components: {
    Navs,
    Foots,
    ForgetPasswd,
    BottomBacktop
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="scss" scoped>

</style>
